export const mapStyle = [
  {
    featureType: "all",
    elementType: "all",
    stylers: [
      { saturation: -100 },
      { lightness: 20 }
    ]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }]
  }
];